import script from "./RegulatoryDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RegulatoryDetails.vue?vue&type=script&setup=true&lang=js"

import "./RegulatoryDetails.vue?vue&type=style&index=0&id=045e49cc&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045e49cc"]])

export default __exports__